var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
const claim = namespace('claim');
const qualification = namespace('qualification');
let NeedHelpToFindLeakageQuestion = class NeedHelpToFindLeakageQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.yesNoQuestionValuesAndTradKeys = YES_OR_NO_CHOICES;
    }
    updateClaim(isHelpToFindLeakageNeeded) {
        this.updateAndSaveWaterDamageQualification({
            qualificationPayload: {
                isHelpToFindLeakageNeeded,
            },
            step: this.step,
        });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.help_to_find_leakage.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.help_to_find_leakage.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (this.waterDamageQualification.isHelpToFindLeakageNeeded === null) {
            return null;
        }
        return this.waterDamageQualification.isHelpToFindLeakageNeeded
            ? this.$tc('claim.qualification.help_to_find_leakage.sumup.yes')
            : this.$tc('claim.qualification.help_to_find_leakage.sumup.no');
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], NeedHelpToFindLeakageQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], NeedHelpToFindLeakageQuestion.prototype, "waterDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], NeedHelpToFindLeakageQuestion.prototype, "updateAndSaveWaterDamageQualification", void 0);
NeedHelpToFindLeakageQuestion = __decorate([
    Component({
        components: { QuestionPanel, RadioPrimaryButton },
        props: QuestionProps,
    })
], NeedHelpToFindLeakageQuestion);
export default NeedHelpToFindLeakageQuestion;
